import { action, makeObservable, observable } from 'mobx';

/**
 * T-0892 (a): the work-item list's search query, as a leaf of its own. The shell's search field, in the
 * top row of every page, reads and writes it, so it is in the launch entry; the rest of the list's view
 * state (`WorkItemViewStore`) loads with the items pages (`workItemViewStoreSlot.ts`). The view store
 * reads and writes the query through this one holder, so both always say the same.
 */
export class WorkItemSearchQuery {
  /** Free-text search over loaded work item keys and visible text; `''` means no search. */
  query = '';
  /**
   * True while the reader's cursor is in the shell's search field.
   *
   * ⚠️ Load-bearing for the seamless switch. Typing the third character navigates to the list, and
   * the address bar is written from the query as it stood at that keystroke — so a reader who keeps
   * typing is, for a moment, ahead of the URL. `hydrateFromUrl` would otherwise write that stale
   * value back and silently eat the character they just typed.
   */
  ownedByInput = false;

  constructor() {
    makeObservable(this, {
      query: observable,
      ownedByInput: observable,
      set: action,
      setOwnedByInput: action,
    });
  }

  set(query: string): void {
    this.query = query;
  }

  setOwnedByInput(owned: boolean): void {
    this.ownedByInput = owned;
  }
}

/** The one search query the shell's field and the list share. */
export const workItemSearchQuery = new WorkItemSearchQuery();
